var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadZoomin = function SvgFadZoomin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.46 158.29c7.647-2.193 17.88-5.434 17.88-5.434l53.514 56.72 17.427-17.63s-59.826-51.997-59.212-53.064c7.41-12.87 13.764-35.47 9.347-50.872-8.65-30.165-40.115-47.607-70.28-38.957-30.165 8.65-47.607 40.115-38.957 70.28 8.65 30.165 40.115 47.607 70.28 38.957z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 104,
    cy: 104,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M111.912 80.047h-15.95v16.037H80v15.992h15.962V128h15.95v-15.924H128V96.084h-16.088z"
  }))));
};
export { SvgFadZoomin as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-zoomin.5022bcd5.svg";